import { apiClient } from '@utils';

export const useGetUserReports = () => {
  const result = apiClient.reports.getReports.useQuery(
    ['getUserReports'],
    {},
    { queryKey: ['getUserReports'], placeholderData: { body: { data: { reports: [] } } } as any },
  );
  return { ...result, data: result.data?.body?.data?.reports ?? [] };
};
